import { useTranslation } from 'react-i18next';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Jumbo } from '@treams/treams-ui';

import OutgoingFeedbackList from './OutgoingFeedbackList';
import ViewerFeedbackButtons from './ViewerFeedbackButtons';
import ViewerFeedbackTabs from './ViewerFeedbackTabs';

export default function ViewerOutgoingFeedback() {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const query = graphql.useOutgoingFeedbackResponsesQuery({
		variables: { userID, last: 10 },
	});

	return (
		<>
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.FeedbackGiven}
				title={t('feedback.outgoing.title')}
				description={t('feedback.outgoing.description')}
				button={<ViewerFeedbackButtons />}
				footer={<ViewerFeedbackTabs />}
			/>
			<OutgoingFeedbackList userID={userID} query={query} />
		</>
	);
}
